const clinicRoutes = {
  onboarding: "/o/onboarding",
  catalog: "/o/catalog",
  catalogProduct: "/o/catalog/products",
  promotions: "/o/catalog/promotions",
  checkout: "/o/checkout",
  wholesalePolicies: "/o/wholesale_policies",
  wholesale_orders: "/o/wholesale_orders",
  naturalPartnersOrders: "/o/wholesale_orders/np",
  treatment_plans: "/o/treatment_plans",
  treatment_plans_new: "/o/treatment_plans/new",
  registerLabPartner: "/o/register_lab_partner",
  patients: "/o/patients",
  patients_import: "/o/patients/import",
  patients_new: "/o/patients/new",
  patients_orders: "/o/patients/orders",
  product_swapping: "/o/product_swapping",
  swapPages: {
    current: "/o/product_swapping/current",
    success: "/o/product_swapping/success",
    past: "/o/product_swapping/past",
  },
  protocols: "/o/protocols",
  protocols_new: "/o/protocols/new",
  protocols_fullscript: "/o/protocols/fullscript",
  choose_practitioner: "/o/choose_practitioner",
  reports: "/o/reports",
  staffs: "/c/staffs", // even though this is /c/ its accessible to pracs as well
  logout: "/logout",
  lab_recommendations: "/o/lab_recommendations",
  support: "https://support.fullscript.com",
  fsTOS: "https://fullscript.com/terms-of-service",
  scheduledAdherenceSurveys:
    "https://support.fullscript.com/hc/en-us/articles/4406531473947-Scheduled-adherence-surveys",
  globalPatientAccessSettings:
    "https://support.fullscript.com/hc/en-us/articles/360061053372-Global-patient-access-settings",
  productCatalogPermissions:
    "https://support.fullscript.com/hc/en-us/articles/360023389512-Product-catalog-and-permissions",
  onSiteProducts: "https://support.fullscript.com/hc/en-us/articles/360029444412-On-site-products",
  favorites: "/o/favorites",
  welcome: "/welcome",
  whats_new: "/o/whats_new",
  integrations: "/o/integrations",
  libraries: "/o/libraries",
  staff_settings: "/o/staff_settings",
  accountSettings: "/o/account_settings",
  accountSettingsBasicInfo: "/o/account_settings/basic_info",
  accountSettingsSecurity: "/o/account_settings/security",
  accountSettingsPreferences: "/o/account_settings/preferences",
  accountSettingsPaymentInfo: "/o/account_settings/payment_info",
  accountSettingsConnectedAccounts: "/o/account_settings/connected_accounts",
  stopImpersonating: "/a/sessions/stop_impersonating",
  integrationDetails: integrationId => `/o/integrations/${integrationId}`,
  newTreatmentPlanForPatient: patientId => `/o/treatment_plans/new?patient_id=${patientId}`,
  choosePractitioner: patientId => `/o/choose_practitioner?patient_id=${patientId}`,
  product: productId => `/o/catalog/products/${productId}`,
  productWithVariant: (productId, variantId) => `/o/catalog/products/${productId}/${variantId}`,
  swapVariant: masterVariantId => `/o/catalog?swap="${masterVariantId}"`,
  officeTreatmentPlansEdit: treatmentPlanId => `/o/treatment_plans/${treatmentPlanId}/edit`,
  patient: id => `/o/patients/${id}`,
  patientTreatmentPlans: id => `/o/patients/${id}/treatment_plans`,
  patientLabs: id => `/o/patients/${id}/labs`,
  patientOrders: id => `/o/patients/${id}/orders`,
  patientStart: id => `/o/patients/${id}/start`,
  patientsEdit: id => `/o/patients/${id}/edit`,
  patientsCheckout: id => `/o/patients/${id}/checkout`,
  protocolsTab: tabId => `/o/protocols/${tabId}`,
  startTreatmentPlanCheckout: (legacyPatientId, legacyTreatmentPlanId) =>
    `/o/patients/${legacyPatientId}/checkout/populate_with_treatment_plan.html?reset_order=true&treatment_plan_id=${legacyTreatmentPlanId}`,
  patientsTreatmentPlanInfo: (patientId, treatmentPlanId) =>
    `/o/patients/${patientId}/treatment_plans/${treatmentPlanId}`,
  patientsOrderInfo: (patientId, orderId) => `/o/patients/${patientId}/orders/${orderId}`,
  peerReferrals: "/o/peer_referrals",
  orderPdfLink: orderNumber => `/o/orders/${orderNumber}.pdf`,
  orderPrintLink: orderNumber => `/o/orders/${orderNumber}.html?print=true`,
  staffEdit: id => `/c/staffs/${id}/edit`,
  recommendationItemResults: (labRecommendationId, labRecommendationItemId, resultId) =>
    `/o/lab_recommendation_item_results/${resultId}?lab_recommendation_id=${labRecommendationId}&lab_recommendation_item_id=${labRecommendationItemId}`,
  recommendationItemRequisition: (labRecommendationId, labRecommendationItemId) =>
    `/o/lab_recommendation_items/${labRecommendationItemId}?lab_recommendation_id=${labRecommendationId}`,
  wellevateMigration: "/o/wellevate_migration",
  deprecated: {
    catalog: "/p/catalog",
    treatment_plan_templates: "/p/treatment_plan_templates",
    treatment_plan_templates_new: "/p/treatment_plan_templates/new",
    storeSettings: "/p/stores/settings",
    dashboard: "/p/stores/dashboard",
    account: "/p/stores/account",
    products: "/p/stores/products",
    certifications: "/p/stores/settings/certifications",
    permissions: "/p/stores/settings/permissions",
    settings_promotions: "/p/stores/settings/store_promotions",
    storeInfo: "/p/stores/settings/info",
    websiteButtons: "/p/stores/settings/website_buttons",
    favorites: "/p/stores/products/catalog/favorites",
    product: productId => `/p/stores/products/catalog/show?productID=${productId}`,
    treatmentPlansEdit: _legacyId => `/p/treatment_plans/${_legacyId}/edit`,
    orders: "/p/stores/orders",
    staffEdit: _legacyId => `/c/staffs/${_legacyId}/edit`,
  },
} as const;

export { clinicRoutes };
